import { createContext, useContext, useState, useCallback } from 'react';
import LeadIntakeModal from '../components/LeadIntakeModal';

const ContactModalContext = createContext();

export const useContactModal = () => {
  const context = useContext(ContactModalContext);
  if (!context) {
    throw new Error('useContactModal must be used within a ContactModalProvider');
  }
  return context;
};

export const ContactModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [productId, setProductId] = useState(null);

  const openContactModal = useCallback((preselectedProductId = null) => {
    setProductId(preselectedProductId);
    setIsOpen(true);
  }, []);

  const closeContactModal = useCallback(() => {
    setIsOpen(false);
    setProductId(null);
  }, []);

  return (
    <ContactModalContext.Provider value={{ openContactModal, closeContactModal }}>
      {children}
      <LeadIntakeModal
        isOpen={isOpen}
        onClose={closeContactModal}
        preselectedProductId={productId}
      />
    </ContactModalContext.Provider>
  );
};
